import { useEstimateMode } from './EstimateModeContext';
import { ESTIMATE_MODES, ESTIMATE_MODE_LABELS, type EstimateMode } from '@/lib/estimate';

/**
 * Global estimate-mode picker for the top bar. Switches every effort figure in the app
 * between the optimistic / expected / pessimistic point of the stored three-point band.
 */
export default function EstimateModeSelect() {
  const { mode, setMode } = useEstimateMode();
  return (
    <label className="estimate-mode" title="Which point of the estimate band to show">
      <span className="muted small">Estimate</span>
      <select
        className="org-switcher"
        value={mode}
        onChange={e => setMode(e.target.value as EstimateMode)}
        aria-label="Estimate mode"
      >
        {ESTIMATE_MODES.map(m => (
          <option key={m} value={m}>
            {ESTIMATE_MODE_LABELS[m]}
          </option>
        ))}
      </select>
    </label>
  );
}
